import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import { logout } from "../../store/features/auth/authSlice";
import {
  fetchUserFailure,
  fetchUserStart,
  fetchUserSuccess,
} from "../../store/features/me/userSlice";

const URL = buildApiUrl("/api/v1/user/me/");

const getMeApi = async (accessToken) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    const apiError = new Error(errorMessage);
    apiError.status = error.response?.status;
    throw apiError;
  }
};

function* fetchMeSaga() {
  try {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      throw new Error("Nessun token di accesso disponibile");
    }
    const userInfo = yield call(getMeApi, accessToken);
    yield put(fetchUserSuccess(userInfo));
  } catch (error) {
    yield put(fetchUserFailure(error.message));
    if (error.status === 401 || error.status === 403) {
      yield put(logout());
    }
  }
}

export default function* meSaga() {
  yield takeLatest(fetchUserStart.type, fetchMeSaga);
}
